import { Box, Button, Chip, Grid, makeStyles, Typography, useMediaQuery } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { StyleProvider } from "../../contexts/StyleContext";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import Header from "../header/Header";
import Photos from "./Photos";
import { useParams } from "react-router-dom";
import { projects } from "../../portfolio";
import Top from "../../containers/topbutton/Top";
import { BsGlobe } from "react-icons/bs";
import { FaGithub } from "react-icons/fa";


const ProjeectDetail = () => {
    const darkPref = window.matchMedia("(prefers-color-scheme: dark)");
    const [isDark, setIsDark] = useLocalStorage("isDark", darkPref.matches);
    const [project, setProject] = useState({});
    const mobileDevice = useMediaQuery('(max-width:670px)');

    // const history = useHistory();
    const { projectId } = useParams();

    useEffect(() => {
        const newProject = projects.projects.find(project => project._id === +projectId);
        setProject(newProject);
    }, [projectId])


    const changeTheme = () => {
        setIsDark(!isDark);
    };

    const useStyles = makeStyles((theme) => ({
        secondGrid: {
            width: "100%",
        },
        modalContainer: {
            width: '100%'
        },
        modalBanner: {
            background: 'linear-gradient(221.44deg, #1AB09D 29.09%, #81DCD1 60.77%)',
            height: 300,
            color: '#fff',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        bannerTitle: {
            fontSize: 50,
            textAlign: 'center'
        },
        bannerSubTitle: {
            fontSize: 25,
            fontWeight: 300,
            textAlign: 'center'
        },
        jobCard: {

            borderRadius: 6,
            boxShadow: '0px 5px 35px rgba(80, 59, 59, 0.05), 0px 3px 6px #CCCCCC',
            padding: 30,
            marginBottom: 16

        },
        contentTitle: {
            fontSize: 26,
            fontWeight: 700,
            marginBottom: 10
        },
        companyLogo: {
            width: 100,
            height: 100,
            padding: 10,
            borderRadius: 100,
            boxShadow: '0px 0px 14px rgba(0, 0, 0, 0.1)',
        },
        smallCardTitle: {
            fontSize: 18,
            fontWeight: 700,
            marginTop: 10
        },
        smallCardLink: {
            fontSize: 14,
            color: '#ccc',
            display: 'flex',
            alignItems: 'center'
        },
        chip: {
            backgroundColor: '#fff',
            border: '1px solid #ff7731',
            color: '#ff7731',
            marginRight: 5,
            marginTop: 5,
            transition: 'all  500ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
            cursor: 'pointer',

            '&:hover': {
                color: '#fff',
                backgroundColor: '#ff7731'
            }

        },
        teamChip: {
            backgroundColor: '#ff7731',
            color: '#fff',
        },
        smallCardSubTitle: {
            fontSize: 14,
            fontWeight: 300
        },
        socialTitle: {
            fontSize: 22,
            fontWeight: 700
        },
        social: {
            fontSize: 50,
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: 35
        },
        socialIcon: {
            marginRight: 10
        }

    }));
    const classes = useStyles();


    return (
        <div className={isDark ? "dark-mode" : null} style={{ paddingBottom: 30 }}>
            <StyleProvider value={{ isDark: isDark, changeTheme: changeTheme }}>
                <Header inProjectDetails />
                <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
                    <Grid container style={{ color: isDark && '#fff', justifyContent: 'center' }}> <Typography
                        style={{ margin: "80px 0 10px 10px", fontSize: 30, textAlign: mobileDevice && 'center' }}
                    >
                        Some Screenshots
                    </Typography>
                        <Grid item >
                            <Grid container >
                                {/* Project Details */}
                                <Grid item style={{ padding: 8 }}>
                                    <Box className={classes.jobCard}>
                                        <Photos snaps={project.snaps} />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item >
                            <Grid container style={{ marginTop: 20 }}>
                                {/* Project Details */}
                                <Grid item style={{ padding: 8 }}>
                                    <Box className={classes.jobCard}>
                                        <Box>
                                            <Typography className={classes.contentTitle}>{project.projectName}</Typography>
                                            <Typography style={{ fontSize: 20 }}>{project.projectDesc}</Typography>
                                        </Box>
                                        <Box style={{ marginTop: 30 }}>
                                            <Typography className={classes.contentTitle}>Key Features </Typography>
                                            {
                                                project?.overview?.map((each, i) => <Typography key={i}>
                                                    • {each}
                                                </Typography>)
                                            }

                                        </Box>

                                        <Box style={{ marginTop: 30 }}>
                                            <Typography className={classes.contentTitle}>Tech Stack</Typography>
                                            {
                                                project?.technologies?.map((each, i) => <Chip label={each} className={classes.chip} key={i} />)
                                            }

                                        </Box>

                                        <Box style={{ marginTop: 30 }}>
                                            <Button target="_blank" href={project.liveLink} color="primary" style={{
                                                fontSize: 16,
                                                '&:hover': {
                                                    color: '#ff7731'
                                                }
                                            }}>
                                                <BsGlobe stylr={{ color: '#003e77' }} /> &nbsp; Live Link
                                            </Button>
                                            <Button target="_blank" href={project.client} color="primary" style={{ fontSize: 16 }}>
                                                <FaGithub stylr={{ color: '#003e77' }} /> &nbsp; Source
                                            </Button>
                                        </Box>

                                        {/* <Box style={{ marginTop: 30 }}>
                                        
                                            <Typography className={classes.contentTitle}>More Information </Typography>
                                            <Typography style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
                                                <BsBriefcase style={{ marginRight: 8, color: '#ff7731', fontSize: 18 }} />
                                                <span style={{ marginRight: 12, fontWeight: 700 }}>Employment Type: </span>
                                                <span style={{ fontSize: 14, fontWeight: 300 }}>Permanent</span>
                                            </Typography>

                                            <Typography style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
                                                <BsHourglassSplit style={{ marginRight: 8, color: '#ff7731', fontSize: 18 }} />
                                                <span style={{ marginRight: 12, fontWeight: 700 }}>Duration: </span>
                                                <span style={{ fontSize: 14, fontWeight: 300 }}>6 months</span>
                                            </Typography>

                                            <Typography style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
                                                <AiOutlineClockCircle style={{ marginRight: 8, color: '#ff7731', fontSize: 18 }} />
                                                <span style={{ marginRight: 12, fontWeight: 700 }}>Hours of work: </span>
                                                <span style={{ fontSize: 14, fontWeight: 300 }}>8 hours</span>
                                            </Typography>

                                            <Typography style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
                                                <BiPaperPlane style={{ marginRight: 8, color: '#ff7731', fontSize: 18 }} />
                                                <span style={{ marginRight: 12, fontWeight: 700 }}>Willing to relocate Canada: </span>
                                                <span style={{ fontSize: 14, fontWeight: 300 }}>Yes</span>
                                            </Typography>
                                        </Box> */}
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>

                        {/* <Grid item className={classes.secondGrid}>
                            <Typography
                                variant="h5"
                                style={{ margin: "80px 0 30px 10px", fontSize: 56, }}
                            >
                                Some Snaps
                            </Typography>
                            <Grid container style={{ width: "100%" }}>
                                <Photos />
                            </Grid>
                        </Grid> */}
                    </Grid>
                </div>

                <Top />
            </StyleProvider >
        </div >
    );
};

export default ProjeectDetail;